<div *ngIf="isDev()">
  <p>HomePageComponent, redirecting to login...</p>
</div>
